import Page from '@/found/components/table_page';
import Form from '../form/index';
import { ProcessLog } from '../../../../../../modules';

export default {
  name: 'material_usage_request',
  extends: Page,
  data() {
    return {
      params: {},
    };
  },
  components: {
    Form,
    ProcessLog,
  },
  created() {
    this.getConfigList('main_list');
  },
  methods: {
    // 控制按钮显示
    clickVisible({ row, val: { code } }) {
      const { approveStatus, processNo } = row;
      if (approveStatus && code === 'edit' && (approveStatus === '1' || approveStatus === '2')) {
        return false;
      }
      if (approveStatus && code === 'project_close' && approveStatus !== '2') {
        return false;
      }
      if (code === 'process_log' && !processNo) {
        return false;
      }
      return true;
    },
    modalClick({ val, row }) {
      const { code } = val;
      console.log('code', code);
      if (code === 'add' || code === 'edit' || code === 'view') {
        this.formConfig = {
          ...this.formConfig,
          code,
          row,
        };
        this.modalConfig.title = val.name || '查看';
        this.openFull();
      } else if (code === 'process_log') {
        this.formConfig = {
          ...this.formConfig,
          code,
          row: { processNo: row.processNo },
        };

        this.modalConfig.title = '流程日志';
        this.formName = 'ProcessLog';
        this.openDrawer();
      } else if (code === 'project_close') {
        this.formConfig = {
          ...this.formConfig,
          code: 'view',
          buttonCode: 'project_close',
          row,
        };
        this.modalConfig.title = '物料申请关闭';
        this.openFull();
      }
    },
  },
};
